import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_UPlOAD_PHARMACY_DOC } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const uploadedPharmacyDoc = createAsyncThunk(
  ACTIONS_UPlOAD_PHARMACY_DOC.postDocumentPharmacy,
  async (data, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        process.env.REACT_APP_API_URL + APP_PATH.uploadedPharmacyDocuments,
        data,
      );

      if (response?.data?.status === true || response?.status === 200) {
        const successMessage = getLocalizedMessage(response, i18n);
        toast.success(successMessage);
        return response.data;
      } else {
        const errorMessage = getLocalizedErrorMessage({ response }, i18n);
        toast.error(errorMessage);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error uploading pharmacy documents:", error);
      const errorMessage = getLocalizedErrorMessage(error, i18n);
      toast.error(errorMessage);
      return rejectWithValue(error?.response?.data || errorMessage);
    }
  },
);
